"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isComponentOfType = isComponentOfType;
function isComponentOfType(classType, reactElement) {
  return reactElement && reactElement.type === classType;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/utils/react.js
// module id = 1221
// module chunks = 0